import React from 'react';
import PropTypes from 'prop-types';
import { palette } from 'styled-theme';
import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import Text from '../../atoms/Text';
import Button from '../../atoms/Button';
import { isDateValid } from '../../../utils/common';

const Container = styled(Flex)`
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 0 22px;
`;

const TermsAndConditionsBox = styled(Flex)`
  flex-direction: column;
  background-color: ${palette('white', 0)};
  max-height: 70vh;
  padding: 0.8rem 1rem 2rem;
  overflow: auto;
  margin-bottom: 1rem;
`;

const terms = [
  <>
    於2020年11月23日至2021年1月3日期間，參加者登記成為H•COINS會員後，於荃灣千色匯或元朗千色匯以智能電話登入找尋Nina及白熊與男孩換領商場優惠券遊戲頁面 (以下簡稱“遊戲頁面”)，集齊3幅圖片後，於該商場的指定地點出示已集齊圖片的頁面及H•COINS會員號碼作登記，即可領取該商場的HK$50購物及HK$50餐飲優惠券各乙張 (以下簡稱“優惠券”)，各商場名額1,500套，數量有限，先到先得，送完即止。<br />
    荃灣千色匯換領地點：荃灣千色匯 I 地下大門 (電訊數碼旁)<br />
    元朗千色匯換領地點：元朗千色匯地下禮賓部旁<br />
    換領地點開放時間：12:00nn - 8:00pm<br />
  </>,
  '每位參加者必須登記成為H•COINS會員方可參與此推廣活動。',
  '參加者掃瞄宣傳品上之QR Code進入遊戲頁面即可開始收集圖片，一經進入遊戲頁面，即代表參加者同意本活動條款及細則。',
  '必需於同一商場集齊3幅不同圖片方為有效。',
  '圖片必須貼在遊戲頁面上，方為有效。',
  '每位參加者於集齊圖片後，必需於遊戲頁面上的指定時間內到指定地點領取優惠券，各商場優惠券名額1,500套，餘額以參加者親身換領時間為準，參加者所持已集齊圖片的遊戲頁面並不代表已預留優惠券。 ',
  '每位H•COINS會員只可換領優惠券乙套，以工作人員的電腦紀錄為準，不得異議。每次只限領取該商場的HK$50購物及HK$50餐飲優惠券各乙張。',
  '顧客必需消費滿HK$100方可使用優惠券乙張，並受優惠券的條款及細則約束，詳情請參閱優惠券背面之使用條款及細則。',
  '優惠券適用之商舖，請參閱優惠券背面之參與商戶名單。',
  '優惠券在任何情況下均不得兌換現金或其他禮品。',
  '活動於2021年1月3日或所有優惠券換領完畢後終結，先到先得，而未能換領優惠券的圖片會自動作廢。',
  '如發現會員有任何舞弊或欺詐行為，其所獲得的電子圖片及禮品將會被即時收回。',
  'H‧COINS之廣告或公關公司職員、參與商場的管理處職員、場內商戶職員和上述職員家屬均不得參加H‧COINS、不得兌換COINS或換領獎賞，以示公允。如有發現，商場禮賓會員專區或禮賓部大使有權拒絕此等登記。如有發現，恒基地產旗下商場可即時取消其會籍資格而不作另行通知。',
  '恒基租務代理有限公司有權隨時更改H‧COINS架構及內容，包括手機應用程式／網站的所有內容、COINS登記、換算COINS方法、COINS有效期、可供換領的獎賞或禮遇、換領及使用獎賞或禮遇方法、條款及細則、其他項目及終止H‧COINS而毋須預先通知會員。會員須留意H‧COINS所有架構及內容，包括本條款及細則的改動。凡會員登記COINS、換領獎賞或使用禮遇，即代表會員接受所有相關的條款及細則。任何因H‧COINS架構及內容，包括本條款及細則改動或更新而導致的損失，恒基租務代理有限公司及恒基地產旗下商場概不負責。',
  '主辦機構保留修改有關細則之最後決定權，如有任何爭議，一概以主辦機構之決定為水準，顧客不得異議。',
];

const TAndCPage = ({ ...props }) => {
  return (
    <Container>
      <TermsAndConditionsBox mt="1rem">
        <Flex justifyContent="center" flexShrink="0">
          <Text variant="body2" fontType="tertiary" palette="grayscale" align="center" bold>活動日期：2020年11月23日至2021年1月3日</Text><br />
        </Flex>
        <Box mt="0.2rem">
          <Text fontType="tertiary" palette="grayscale" variant="body3">活動條款及細則：</Text>
          {terms.map((term, i) => (
            <Flex key={`term-${i}`}>
              <Flex mr={i + 1 < 10 ? '0.6rem' : '0.2rem'}>
                <Text fontType="tertiary" palette="grayscale" variant="body3">{i + 1}.</Text>
              </Flex>
              <Text fontType="tertiary" palette="grayscale" variant="body3">
                {term}
              </Text>
            </Flex>
          ))}
        </Box>
      </TermsAndConditionsBox>
      <Button to="/" disabled={!isDateValid()}>
        <Text variant="h3">同意</Text>
      </Button>
    </Container>
  );
};

TAndCPage.propTypes = {

};

TAndCPage.defaultProps = {

};

export default TAndCPage;
